import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressTabs from '../components/ProgressTabs';
import SweatTextTitle from '../steps/SweatTextTitle';
import RemindersInfo from './RemindersInfo';
import '../BasicReminder.css';
import { getBackendURL } from '../utils';
import { useAuth } from '../auth';

const StepClientName = () => {
  const [clientName, setClientName] = useState('');
  const [creating, setCreating] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleNext = async () => {
    if (!user || !clientName) return;
    setCreating(true);
    try {
      await fetch(getBackendURL() + `/client?user_id=${user.id}`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${window.localStorage.getItem('ptc_access_token') || ''}`
          },
          body: JSON.stringify({ 
            trainer_info_id: user.trainer_info?.id,
            pre_user_name: clientName })
        }
      );
      navigate('/tools/reminders/stepnextappointment');
    } catch (err) {
      alert('Failed to create client.');
    } finally {
      setCreating(false);
    }
  };

  // If no user redirect to homepage.
  if (!user) {
    return (
      <div className="reminder-container fogged-card">
        Sorry, you must be logged in to access this page.
      </div>
    );
  } 

  return (
    <div className="reminder-container fogged-card">
      <SweatTextTitle />
      <RemindersInfo />
      <ProgressTabs currentStep={4} />
      <h2 className="step-title">Step 5: Who is the next client you are going to meet?</h2>
      <p>Enter a nickname for them.</p>
      <p>This will all be editable in the dashboard later.</p>
      <input
        type="text"
        value={clientName}
        onChange={e => setClientName(e.target.value)}
        placeholder="e.g. Jen, Boss, Bro..."
        style={{ padding: '0.75rem 1rem', fontSize: '1rem', width: '100%', maxWidth: '400px', marginBottom: '1.5rem', borderRadius: '6px', border: '1px solid #ccc' }}
      />
      <div>

          {clientName && (
            <button
              className="ptc-button"
              style={{ padding: '1rem 2rem', fontSize: '1rem' }}
              onClick={handleNext}
              disabled={creating}
            >
              {creating ? 'Saving...' : 'Next'}
            </button>
          )}

          
          {!clientName && (
            <button
            disabled
              className="ptc-button"
              style={{ cursor: 'not-allowed',
                background: '#ccc', color: '#222',
                border: 'none',
                padding: '1rem 2rem', fontSize: '1rem' }}
              onClick={() => navigate('/tools/reminders/stepnextappointment')}
            >
              Next
            </button>
          )}
          
      </div>

          <div>
            
            {!clientName && (
              <button
                className="ptc-secondary-button"
                onClick={() => navigate('/tools/reminders/dashboard')}
              >
                Skip to dashboard - let's invite a client later. 
              </button>
            )}

          </div>
          <div>
            
            <button
              className="ptc-secondary-button"
              style={{ padding: '1rem 2rem', fontSize: '1rem', background: '#777', color: '#222', border: 'none' }}
              onClick={() => navigate('/tools/reminders/step-trainer-test')}
            >
              Previous Step
            </button>
          </div>
    </div>
  );
};

export default StepClientName;
